<!-- src/components/UserInfo.vue -->
<template>
  <div class="user_info">
    <div class="content">
      <div class="avatar-container">
        <div class="avatar">
          <span class="avatar-text">{{ avatarText }}</span>
        </div>
      </div>
      
      <div class="user-details">
        <div class="username-container">
          <div v-if="!isEditingUsername" class="username-display">
            <h3 class="username">{{ displayName }}</h3>
            <el-tooltip content="修改用户名" placement="top" effect="light">
              <i class="el-icon-edit username-edit-icon" @click="startEditUsername"></i>
            </el-tooltip>
          </div>
          <div v-else class="username-edit">
            <el-input
              ref="usernameInput"
              v-model="editingUsername"
              size="small"
              class="username-input"
              maxlength="20"
            ></el-input>
            <div class="edit-actions">
              <el-button 
                type="primary" 
                size="mini" 
                icon="el-icon-check"
                @click="confirmEditUsername"
                circle
                class="confirm-btn"
              ></el-button>
              <el-button 
                size="mini" 
                icon="el-icon-close"
                @click="cancelEditUsername"
                circle
                class="cancel-btn"
              ></el-button>
            </div>
          </div>
        </div>
        <p class="email">{{ userEmail }}</p>
      </div>
      
      <div class="actions">
        <button class="btn btn-secondary" @click="handleLogout">
          <i class="icon-logout">🚪</i>
          注销账户
        </button>
        <button class="btn btn-primary" @click="handleSignOut">
          <i class="icon-signout">👋</i>
          退出登录
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { user_logout_path, user_update_name_path } from '@/js/api_paths';
export default {
  name: 'UserInfo',
  data() {
    return {
      isEditingUsername: false,
      editingUsername: '',
      isSubmitting: false
    }
  },
  computed: {
    // 从 Vuex 或 localStorage 获取用户信息
    username() {
      return this.$store?.state.username || localStorage.getItem('username') || '用户';
    },
    
    userEmail() {
      return this.$store?.state.email || localStorage.getItem('userEmail') || 'user@example.com';
    },
    
    // 显示用户名（如果过长则截断）
    displayName() {
      const name = this.username;
      return name && name.length > 8 ? name.substring(0, 8) + '..' : name;
    },
    
    // 头像显示文字（取用户名首字母）
    avatarText() {
      return this.username ? this.username.charAt(0).toUpperCase() : 'U';
    }
  },
  
  methods: {
    startEditUsername() {
      this.isEditingUsername = true;
      this.editingUsername = this.username;
      this.$nextTick(() => {
        this.$refs.usernameInput.focus();
      });
    },
    
    async confirmEditUsername() {
      // 防止重复提交
      if (this.isSubmitting) {
        return;
      }
      
      this.isSubmitting = true;
      
      try {
        // 验证用户名
        if (this.editingUsername.trim() === '') {
          this.$message({
            type: 'warning',
            message: '用户名不能为空',
            duration: 1500
          });
          return;
        }
        
        if (this.editingUsername.length < 2 || this.editingUsername.length > 20) {
          this.$message({
            type: 'warning',
            message: '用户名长度必须在2-20个字符之间',
            duration: 1500
          });
          return;
        }
        
        // 如果用户名没有改变，直接取消编辑
        if (this.editingUsername === this.username) {
          this.cancelEditUsername();
          return;
        }
        
        const response = await fetch(user_update_name_path, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            username: this.editingUsername
          })
        });
        
        const data = await response.json();
        
        if (data.status === "success") {
          // 更新本地存储和 Vuex 状态
          localStorage.setItem('username', this.editingUsername);
          if (this.$store) {
            this.$store.commit('SET_USERNAME', this.editingUsername);
          }
          
          this.isEditingUsername = false;
          
          this.$message({
            type: 'success',
            message: '用户名更新成功',
            duration: 1500
          });
        } else {
          this.$message({
            type: 'error',
            message: data.msg || '用户名更新失败',
            duration: 1500
          });
        }
      } catch (error) {
        console.error('更新用户名失败:', error);
        this.$message({
          type: 'error',
          message: '网络错误，请稍后重试',
          duration: 1500
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    
    cancelEditUsername() {
      this.isEditingUsername = false;
      this.editingUsername = '';
    },
    
    async handleLogout() {
      try {
          await this.$confirm('该操作将删除您账号的所有记录', '确认注销',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          });
          
          fetch(user_logout_path, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
              'Content-Type': 'application/json'
            }
          })
          .then((res) => {
            return res.json();
          })
          .then((data) => {
            if(data.status == "success"){
              localStorage.removeItem('token');
              localStorage.removeItem('username');
              localStorage.removeItem('email');
              this.$store.commit('SET_IS_LOGIN', false);
              
              this.$router.push('/Login');
              
              this.$message({
                type: 'success',
                message: '账号已注销',
                duration: 1500
              });
            }
            else{
              this.$message({
                type: 'error',
                message: '注销失败',
                duration: 1500
              });
            }
            
          })
          .catch((error) => {
            console.log(error);
          })
          
          
        } catch (error) {
          this.$message({
            type: 'info',
            message: '已取消注销',
            duration: 1000
          });
        }
    },

    
    async handleSignOut() {
      try {
          await this.$confirm('确定要退出登录吗？', '确认退出', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          });
          
          localStorage.removeItem('token');
          localStorage.removeItem('username');
          localStorage.removeItem('email');
          this.$store.commit('SET_IS_LOGIN', false);
          this.$router.push('/Login');
          
          this.$message({
            type: 'success',
            message: '已退出登录',
            duration: 1500
          });
          
        } catch (error) {
          this.$message({
            type: 'info',
            message: '已取消退出',
            duration: 1000
          });
        }
    },
  }
}
</script>

<style scoped>
.user_info {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px;
  border-radius: 12px 12px 0 0;
  background: linear-gradient(135deg, rgba(237, 233, 254, 0.7) 0%, rgba(224, 219, 255, 0.8) 100%);
  backdrop-filter: blur(10px);
  position: relative;
}

.content {
  text-align: center;
  color: #64748b;
  width: 100%;
  max-width: 400px;
}

.avatar-container {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.avatar-container:hover {
  transform: scale(1.05);
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  font-weight: bold;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.user-details {
  margin-bottom: 30px;
}

.username-container {
  margin-bottom: 10px;
}

.username-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.username {
  margin: 0;
  color: #475569;
  font-size: 20px;
  font-weight: 600;
}

.username-edit-icon {
  font-size: 18px;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 4px;
  border-radius: 4px;
}

.username-edit-icon:hover {
  color: #667eea;
  background-color: rgba(102, 126, 234, 0.1);
  transform: scale(1.1);
}

.username-edit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.username-input {
  width: 180px;
}

.username-input ::v-deep .el-input__inner {
  height: 32px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.edit-actions {
  display: flex;
  gap: 4px;
}

.confirm-btn {
  background: linear-gradient(135deg, #cdb4db 0%, #a27bc0 100%) !important;
  border: none !important;
}

.confirm-btn:hover {
  background: linear-gradient(135deg, #bda4cb 0%, #926bb0 100%) !important;
  transform: translateY(-1px);
}

.cancel-btn {
  background: #f1f5f9 !important;
  border: 1px solid #e2e8f0 !important;
  color: #64748b !important;
}

.cancel-btn:hover {
  background: #e2e8f0 !important;
  transform: translateY(-1px);
}

.email {
  margin: 0 0 5px 0;
  color: #64748b;
  font-size: 16px;
  word-break: break-all;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-secondary {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn:active {
  transform: translateY(0);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}

.btn-secondary:hover {
  background: #e2e8f0;
}

.icon-logout,
.icon-signout {
  font-size: 18px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .avatar {
    width: 80px;
    height: 80px;
    font-size: 32px;
  }
  
  .username {
    font-size: 20px;
  }
  
  .username-input {
    width: 150px;
  }
  
  .username-input ::v-deep .el-input__inner {
    font-size: 18px;
    height: 28px;
  }
  
  .username-display {
    gap: 8px;
  }
  
  .username-edit-icon {
    font-size: 16px;
  }
  
  .btn {
    padding: 10px 16px;
    font-size: 14px;
  }
}
</style>